import React from "react";
import imageKozijn from '../../../images/situation/maten/kozijn/M.jpg';
import imageMuur from '../../../images/situation/maten/muur/M.jpg';
import PropTypes from "prop-types";

MaatM.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    isMuurMontage: PropTypes.bool.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function MaatM(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u de maat van voorkant kozijn tot voorkant muur invullen.<br/>
        </div>
        <div className="phone-situation-description">
            Deze maat wordt ook wel de neggemaat genoemd.
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de maat in..."
        />
        <img className="explainImagePhone" src={props.isMuurMontage ? imageMuur : imageKozijn} alt=""/>
    </div>;
}